import { render, staticRenderFns } from "./VaPaletteCustom.vue?vue&type=template&id=25f46680&"
import script from "./VaPaletteCustom.vue?vue&type=script&lang=js&"
export * from "./VaPaletteCustom.vue?vue&type=script&lang=js&"
import style0 from "./VaPaletteCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports